module.exports = __webpack_public_path__ + "static/media/dots-icon.1f89569e.svg";